'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var auth = require('@tarslib/types/lib/auth');
var securityScheme = require('@tarslib/types/lib/securityScheme');
var appRegion = require('@tarslib/utils/lib/utils/appRegion');
var lodash = require('lodash');
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r);
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
var securitySchemeName = 'securityScheme';
var apiKeyDefaultName = 'Authorization';
var authConfigsName = 'authConfigs';
var authTypeName = 'authType';
var typeName = 'type';
var inName = 'in';
var schemeName = 'scheme';
var flowsName = 'flows';
var bearerFormatName = 'bearerFormat';
var useGrantType = 'useGrantType';
var accessToken = 'accessToken';
var getExtendedFieldName = function getExtendedFieldName() {
  return "x-".concat(appRegion.getAppNameLower());
};
var getAuthConfigsExtendedFieldBaseFormItemName = function getAuthConfigsExtendedFieldBaseFormItemName() {
  return [authConfigsName, getExtendedFieldName()];
};
var authConfigsTypeFormItemName = [authConfigsName, typeName];
var authConfigsInFormItemName = [authConfigsName, inName];
var authConfigsNameFormItemName = [authConfigsName, 'name'];
var authConfigsGroupFormItemName = [authConfigsName, 'group'];
var getAuthConfigsValueFormItemName = function getAuthConfigsValueFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['value']);
};
var authConfigsSchemeFormItemName = [authConfigsName, schemeName];
var authConfigsFlowsFormItemName = [authConfigsName, flowsName];
var authConfigsBearerFormatFormItemName = [authConfigsName, bearerFormatName];
var useOverrideNamePath = [securitySchemeName, 'useOverride'];
var configsBaseNamePathInUseOverride = [].concat(useOverrideNamePath, ['configs']);
var getConfigsForSechemeBaseNamePathInUseOverride = function getConfigsForSechemeBaseNamePathInUseOverride(schemeId) {
  return [].concat(_toConsumableArray(configsBaseNamePathInUseOverride), ["".concat(schemeId)]);
};
var useCaseNamePathBase = [securitySchemeName, 'use'];
var configsBaseNamePathInUseCase = [].concat(useCaseNamePathBase, ['configs']);
var getConfigsForSechemeBaseNamePathInUseCase = function getConfigsForSechemeBaseNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(configsBaseNamePathInUseCase), ["".concat(schemeId)]);
};

// Bearer Token
var getBearerTokenTokenFormItemName = function getBearerTokenTokenFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['token']);
};
var getBearerTokenTokenNamePathInUseCase = function getBearerTokenTokenNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getBearerTokenTokenFormItemName()));
};

// JWT
var getJwtAddTokenToFormItemName = function getJwtAddTokenToFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['addTokenTo']);
};
var getJwtHeaderPrefixFormItemName = function getJwtHeaderPrefixFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['headerPrefix']);
};
var getJwtAlgorithmFormItemName = function getJwtAlgorithmFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['algorithm']);
};
var getJwtQueryParamKeyFormItemName = function getJwtQueryParamKeyFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['queryParamKey']);
};
var getJwtSecretFormItemName = function getJwtSecretFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['secret']);
};
var getJwtSecretNamePathInUseCase = function getJwtSecretNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtSecretFormItemName()));
};
var getJwtTokenFormItemName = function getJwtTokenFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['token']);
};
var getJwtTokenNamePathInUseCase = function getJwtTokenNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtTokenFormItemName()));
};
var getJwtIsSecretBase64EncodedFormItemName = function getJwtIsSecretBase64EncodedFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['isSecretBase64Encoded']);
};
var getJwtIsSecretBase64EncodedNamePathInUseCase = function getJwtIsSecretBase64EncodedNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtIsSecretBase64EncodedFormItemName()));
};
var getJwtPrivateKeyFormItemName = function getJwtPrivateKeyFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['privateKey']);
};
var getJwtPrivateKeyNamePathInUseCase = function getJwtPrivateKeyNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtPrivateKeyFormItemName()));
};
var getJwtPayloadFormItemName = function getJwtPayloadFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['payload']);
};
var getJwtPayloadNamePathInUseCase = function getJwtPayloadNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtPayloadFormItemName()));
};
var getJwtHeaderFormItemName = function getJwtHeaderFormItemName() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['header']);
};
var getJwtHeaderNamePathInUseCase = function getJwtHeaderNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getJwtHeaderFormItemName()));
};

// Basic Auth
var getBasicUsernameNamePath = function getBasicUsernameNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['username']);
};
var getBasicUsernameNamePathInUseCase = function getBasicUsernameNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getBasicUsernameNamePath()));
};
var getBasicPasswordNamePath = function getBasicPasswordNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['password']);
};
var getBasicPasswordNamePathInUseCase = function getBasicPasswordNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getBasicPasswordNamePath()));
};

// Digest Auth
var getDigestAlgorithmNamePath = function getDigestAlgorithmNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['algorithm']);
};
var getDigestUsernameNamePath = function getDigestUsernameNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['username']);
};
var getDigestUsernameNamePathInUseCase = function getDigestUsernameNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestUsernameNamePath()));
};
var getDigestPasswordNamePath = function getDigestPasswordNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['password']);
};
var getDigestPasswordNamePathInUseCase = function getDigestPasswordNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestPasswordNamePath()));
};
var getDigestDisableRetryRequestNamePath = function getDigestDisableRetryRequestNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['disableRetryRequest']);
};
var getDigestDisableRetryRequestNamePathInUseCase = function getDigestDisableRetryRequestNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestDisableRetryRequestNamePath()));
};
var getDigestRealmNamePath = function getDigestRealmNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['realm']);
};
var getDigestRealmNamePathInUseCase = function getDigestRealmNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestRealmNamePath()));
};
var getDigestNonceNamePath = function getDigestNonceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['nonce']);
};
var getDigestNonceNamePathInUseCase = function getDigestNonceNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestNonceNamePath()));
};
var getDigestQopNamePath = function getDigestQopNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['qop']);
};
var getDigestQopNamePathInUseCase = function getDigestQopNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestQopNamePath()));
};
var getDigestNonceCountNamePath = function getDigestNonceCountNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['nonceCount']);
};
var getDigestNonceCountNamePathInUseCase = function getDigestNonceCountNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestNonceCountNamePath()));
};
var getDigestClientNonceNamePath = function getDigestClientNonceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['clientNonce']);
};
var getDigestClientNonceNamePathInUseCase = function getDigestClientNonceNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestClientNonceNamePath()));
};
var getDigestOpaqueNamePath = function getDigestOpaqueNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['opaque']);
};
var getDigestOpaqueNamePathInUseCase = function getDigestOpaqueNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getDigestOpaqueNamePath()));
};

// OAuth 1
var getOAuth1SignatureMethodNamePath = function getOAuth1SignatureMethodNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['signatureMethod']);
};
var getOAuth1AddTokenToNamePath = function getOAuth1AddTokenToNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['in']);
};
var getOAuth1ConsumerKeyNamePath = function getOAuth1ConsumerKeyNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['consumerKey']);
};
var getOAuth1ConsumerSecretNamePath = function getOAuth1ConsumerSecretNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['consumerSecret']);
};
var getOAuth1IncludeBodyHashNamePath = function getOAuth1IncludeBodyHashNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['includeBodyHash']);
};
var getOAuth1AddEmptyParamsToSignNamePath = function getOAuth1AddEmptyParamsToSignNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['addEmptyParamsToSign']);
};
var getOAuth1EnableHeaderEncodingNamePath = function getOAuth1EnableHeaderEncodingNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['enableHeaderEncoding']);
};
var getOAuth1TokenNamePath = function getOAuth1TokenNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['token']);
};
var getOAuth1TokenNamePathInUseCase = function getOAuth1TokenNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1TokenNamePath()));
};
var getOAuth1TokenSecretNamePath = function getOAuth1TokenSecretNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['tokenSecret']);
};
var getOAuth1TokenSecretNamePathInUseCase = function getOAuth1TokenSecretNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1TokenSecretNamePath()));
};
var getOAuth1PrivateKeyNamePath = function getOAuth1PrivateKeyNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['privateKey']);
};
var getOAuth1PrivateKeyNamePathInUseCase = function getOAuth1PrivateKeyNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1PrivateKeyNamePath()));
};
var getOAuth1CallbackNamePath = function getOAuth1CallbackNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['callback']);
};
var getOAuth1CallbackNamePathInUseCase = function getOAuth1CallbackNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1CallbackNamePath()));
};
var getOAuth1VerifierNamePath = function getOAuth1VerifierNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['verifier']);
};
var getOAuth1VerifierNamePathInUseCase = function getOAuth1VerifierNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1VerifierNamePath()));
};
var getOAuth1TimestampNamePath = function getOAuth1TimestampNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['timestamp']);
};
var getOAuth1TimestampNamePathInUseCase = function getOAuth1TimestampNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1TimestampNamePath()));
};
var getOAuth1NonceNamePath = function getOAuth1NonceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['nonce']);
};
var getOAuth1NonceNamePathInUseCase = function getOAuth1NonceNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1NonceNamePath()));
};
var getOAuth1VersionNamePath = function getOAuth1VersionNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['version']);
};
var getOAuth1VersionNamePathInUseCase = function getOAuth1VersionNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1VersionNamePath()));
};
var getOAuth1RealmNamePath = function getOAuth1RealmNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['realm']);
};
var getOAuth1RealmNamePathInUseCase = function getOAuth1RealmNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getOAuth1RealmNamePath()));
};

// Hawk
var getHawkAlgorithmNamePath = function getHawkAlgorithmNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['algorithm']);
};
var getHawkIncludePayloadHashNamePath = function getHawkIncludePayloadHashNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['includePayloadHash']);
};
var getHawkSchemeNamePath = function getHawkSchemeNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['scheme']);
};
var getHawkAuthIdNamePath = function getHawkAuthIdNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['authId']);
};
var getHawkAuthIdNamePathInUseCase = function getHawkAuthIdNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkAuthIdNamePath()));
};
var getHawkAuthKeyNamePath = function getHawkAuthKeyNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['authKey']);
};
var getHawkAuthKeyNamePathInUseCase = function getHawkAuthKeyNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkAuthKeyNamePath()));
};
var getHawkUserNamePath = function getHawkUserNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['user']);
};
var getHawkUserNamePathInUseCase = function getHawkUserNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkUserNamePath()));
};
var getHawkNonceNamePath = function getHawkNonceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['nonce']);
};
var getHawkNonceNamePathInUseCase = function getHawkNonceNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkNonceNamePath()));
};
var getHawkExtraDataNamePath = function getHawkExtraDataNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['extraData']);
};
var getHawkExtraDataNamePathInUseCase = function getHawkExtraDataNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkExtraDataNamePath()));
};
var getHawkAppNamePath = function getHawkAppNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['app']);
};
var getHawkAppNamePathInUseCase = function getHawkAppNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkAppNamePath()));
};
var getHawkDelegationNamePath = function getHawkDelegationNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['delegation']);
};
var getHawkDelegationNamePathInUseCase = function getHawkDelegationNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkDelegationNamePath()));
};
var getHawkTimestampNamePath = function getHawkTimestampNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['timestamp']);
};
var getHawkTimestampNamePathInUseCase = function getHawkTimestampNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getHawkTimestampNamePath()));
};

// AWS
var getAwsSchemeNamePath = function getAwsSchemeNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['scheme']);
};
var getAwsRegionNamePath = function getAwsRegionNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['region']);
};
var getAwsServiceNamePath = function getAwsServiceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['service']);
};
var getAwsAccessKeyNamePath = function getAwsAccessKeyNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['accessKey']);
};
var getAwsAccessKeyNamePathInUseCase = function getAwsAccessKeyNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getAwsAccessKeyNamePath()));
};
var getAwsSecretKeyNamePath = function getAwsSecretKeyNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['secretKey']);
};
var getAwsSecretKeyNamePathInUseCase = function getAwsSecretKeyNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getAwsSecretKeyNamePath()));
};
var getAwsSessionTokenNamePath = function getAwsSessionTokenNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['sessionToken']);
};
var getAwsSessionTokenNamePathInUseCase = function getAwsSessionTokenNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getAwsSessionTokenNamePath()));
};

// Kerberos
var getNegotiateProviderNamePath = function getNegotiateProviderNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['provider']);
};
var getKerberosServiceNamePath = function getKerberosServiceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['service']);
};
var getKerberosMechOidNamePath = function getKerberosMechOidNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['mech_oid']);
};
var getKerberosMechOidNamePathInUseCase = function getKerberosMechOidNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getKerberosMechOidNamePath()));
};

// NTLM
var getNtlmDomainNamePath = function getNtlmDomainNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['domain']);
};
var getNtlmWorkstationNamePath = function getNtlmWorkstationNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['workstation']);
};
var getNtlmDisableRetryRequestNamePath = function getNtlmDisableRetryRequestNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['disableRetryRequest']);
};
var getNtlmUsernameNamePath = function getNtlmUsernameNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['username']);
};
var getNtlmUsernameNamePathInUseCase = function getNtlmUsernameNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getNtlmUsernameNamePath()));
};
var getNtlmPasswordNamePath = function getNtlmPasswordNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['password']);
};
var getNtlmPasswordNamePathInUseCase = function getNtlmPasswordNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getNtlmPasswordNamePath()));
};

// EdgeGrid
var getEdgeGridSchemeNamePath = function getEdgeGridSchemeNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['scheme']);
};
var getEdgeGridClientTokenNamePath = function getEdgeGridClientTokenNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['clientToken']);
};
var getEdgeGridClientSecretNamePath = function getEdgeGridClientSecretNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['clientSecret']);
};
var getEdgeGridAccessTokenNamePath = function getEdgeGridAccessTokenNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), [accessToken]);
};
var getEdgeGridAccessTokenNamePathInUseCase = function getEdgeGridAccessTokenNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getEdgeGridAccessTokenNamePath()));
};
var getEdgeGridNonceNamePath = function getEdgeGridNonceNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['nonce']);
};
var getEdgeGridNonceNamePathInUseCase = function getEdgeGridNonceNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getEdgeGridNonceNamePath()));
};
var getEdgeGridTimestampNamePath = function getEdgeGridTimestampNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['timestamp']);
};
var getEdgeGridTimestampNamePathInUseCase = function getEdgeGridTimestampNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getEdgeGridTimestampNamePath()));
};
var getEdgeGridBaseURLNamePath = function getEdgeGridBaseURLNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['baseURL']);
};
var getEdgeGridBaseURLNamePathInUseCase = function getEdgeGridBaseURLNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getEdgeGridBaseURLNamePath()));
};
var getEdgeGridHeadersToSignNamePath = function getEdgeGridHeadersToSignNamePath() {
  return [].concat(_toConsumableArray(getAuthConfigsExtendedFieldBaseFormItemName()), ['headersToSign']);
};
var getEdgeGridHeadersToSignNamePathInUseCase = function getEdgeGridHeadersToSignNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getEdgeGridHeadersToSignNamePath()));
};

//
var getOAuth2GrantTypeNamePathInUseCase = function getOAuth2GrantTypeNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), [useGrantType]);
};
var getAuthConfigsAccessTokenFormItemNameInUseCase = function getAuthConfigsAccessTokenFormItemNameInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), ['accessToken']);
};
var getAuthConfigsTokenDetailFormItemNameInUseCase = function getAuthConfigsTokenDetailFormItemNameInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), ['tokenDetail']);
};
var getAuthConfigsNamePathInUseCase = function getAuthConfigsNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), [authConfigsName]);
};
var getApiKeyValueNamePathInUseCase = function getApiKeyValueNamePathInUseCase(schemeId) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getAuthConfigsValueFormItemName()));
};
function getOAuth2FlowsFieldBaseFormItemName(flowName) {
  return [].concat(authConfigsFlowsFormItemName, [flowName]);
}
function getOAuth2FlowsExtendedFieldBaseFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsFieldBaseFormItemName(flowName)), [getExtendedFieldName()]);
}
function getAddTokenToFromItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['addTokenTo']);
}
function getUseTokenTypeFromItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['useTokenType']);
}
function getAuthorizationUrlFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsFieldBaseFormItemName(flowName)), ['authorizationUrl']);
}
function getAuthRequestParamsFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['authRequestParams']);
}
function getTokenUrlFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsFieldBaseFormItemName(flowName)), ['tokenUrl']);
}
function getTokenRequestParamsFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['tokenRequestParams']);
}
var clientIdFormItemName = 'clientId';
function getClientIdFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), [clientIdFormItemName]);
}
var clientSecretFormItemName = 'clientSecret';
function getClientSecretFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), [clientSecretFormItemName]);
}
function getCredentialsFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['clientAuthentication']);
}
function getHeaderPrefixFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['headerPrefix']);
}
function getHeaderKeyFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['headerKey']);
}
function getQueryParamKeyFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['queryParamKey']);
}
function getCallbackUrlFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['redirectUri']);
}
function getRefreshUrlFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsFieldBaseFormItemName(flowName)), ['refreshUrl']);
}
function getRefreshRequestParamsFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['refreshRequestParams']);
}
function getUseTokenConfigAsRefreshTokenConfigFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['useTokenConfigAsRefreshTokenConfig']);
}
var scopesFormItemName = 'scopes';
function getScopesFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsFieldBaseFormItemName(flowName)), [scopesFormItemName]);
}
function getStateFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['state']);
}
function getChallengeAlgorithmFromItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['challengeAlgorithm']);
}
function getCodeVerifierFromItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), ['codeVerifier']);
}
var usernameFormItemName = 'username';
function getUserNameFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), [usernameFormItemName]);
}
function getUserNameFormItemNameInUseCase(schemeId, flowName) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getUserNameFormItemName(flowName)));
}
var passwordFormItemName = 'password';
function getPasswordFormItemName(flowName) {
  return [].concat(_toConsumableArray(getOAuth2FlowsExtendedFieldBaseFormItemName(flowName)), [passwordFormItemName]);
}
function getPasswordFormItemNameInUseCase(schemeId, flowName) {
  return [].concat(_toConsumableArray(getConfigsForSechemeBaseNamePathInUseCase(schemeId)), _toConsumableArray(getPasswordFormItemName(flowName)));
}
function getGrantType(flowType, codeVerifier) {
  switch (flowType) {
    case auth.OAuth2FlowsType.AUTHORIZATION_CODE:
      if (codeVerifier) {
        return auth.OAuth2GrantType.AUTHORIZATION_CODE_WITH_PKCE;
      }
      return auth.OAuth2GrantType.AUTHORIZATION_CODE;
    case auth.OAuth2FlowsType.CLIENT_CREDENTIALS:
      return auth.OAuth2GrantType.CLIENT_CREDENTIALS;
    case auth.OAuth2FlowsType.PASSWORD:
      return auth.OAuth2GrantType.PASSWORD_CREDENTIALS;
    case auth.OAuth2FlowsType.IMPLICIT:
      return auth.OAuth2GrantType.IMPLICIT;
    default:
      return auth.OAuth2GrantType.AUTHORIZATION_CODE;
  }
}
function getOAuth2(flowType, values) {
  var addTokenTo = lodash.get(values, getAddTokenToFromItemName(flowType));
  var useTokenType = lodash.get(values, getUseTokenTypeFromItemName(flowType));
  var authRequestParams = lodash.get(values, getAuthRequestParamsFormItemName(flowType)) || [];
  var accessTokenUrl = lodash.get(values, getTokenUrlFormItemName(flowType));
  var tokenRequestParams = lodash.get(values, getTokenRequestParamsFormItemName(flowType)) || [];
  var authUrl = lodash.get(values, getAuthorizationUrlFormItemName(flowType));
  var clientId = lodash.get(values, getClientIdFormItemName(flowType));
  var clientSecret = lodash.get(values, getClientSecretFormItemName(flowType));
  var clientAuthentication = lodash.get(values, getCredentialsFormItemName(flowType));
  var headerPrefix = lodash.get(values, getHeaderPrefixFormItemName(flowType));
  var queryParamKey = lodash.get(values, getQueryParamKeyFormItemName(flowType));
  var callbackUrl = lodash.get(values, getCallbackUrlFormItemName(flowType));
  var refreshUrl = lodash.get(values, getRefreshUrlFormItemName(flowType));
  var refreshRequestParams = lodash.get(values, getRefreshRequestParamsFormItemName(flowType)) || [];
  var useTokenConfigAsRefreshTokenConfig = lodash.get(values, getUseTokenConfigAsRefreshTokenConfigFormItemName(flowType));
  var scopes = lodash.get(values, getScopesFormItemName(flowType)) || {};
  var state = lodash.get(values, getStateFormItemName(flowType));
  var challengeAlgorithm = lodash.get(values, getChallengeAlgorithmFromItemName(flowType));
  var codeVerifier = lodash.get(values, getCodeVerifierFromItemName(flowType));
  var userName = lodash.get(values, getUserNameFormItemName(flowType));
  var password = lodash.get(values, getPasswordFormItemName(flowType));
  var headerKey = lodash.get(values, getHeaderKeyFormItemName(flowType));
  var grantType = getGrantType(flowType, codeVerifier);
  var scope = '';
  if (Array.isArray(scopes)) {
    scope = scopes.join(' ');
  } else if (_typeof(scopes) === 'object') {
    scope = Object.keys(scopes).join(' ');
  } else if (scopes) {
    scope = scopes;
  }
  var oauth2 = {
    addTokenTo: addTokenTo,
    useTokenType: useTokenType,
    grant_type: grantType,
    authRequestParams: authRequestParams,
    accessTokenUrl: accessTokenUrl,
    tokenRequestParams: tokenRequestParams,
    authUrl: authUrl,
    clientId: clientId,
    clientSecret: clientSecret,
    client_authentication: clientAuthentication,
    headerPrefix: headerPrefix,
    queryParamKey: queryParamKey,
    redirect_uri: callbackUrl,
    refreshTokenUrl: refreshUrl,
    refreshRequestParams: refreshRequestParams,
    useTokenConfigAsRefreshTokenConfig: useTokenConfigAsRefreshTokenConfig,
    scope: scope,
    state: state,
    challengeAlgorithm: challengeAlgorithm,
    code_verifier: codeVerifier,
    username: userName,
    password: password,
    headerKey: headerKey
  };
  return oauth2;
}
function getApiKey(values) {
  var addTokenTo = lodash.get(values, authConfigsInFormItemName);
  var name = lodash.get(values, authConfigsNameFormItemName);
  var value = lodash.get(values, getAuthConfigsValueFormItemName());
  return {
    "in": addTokenTo,
    key: name,
    value: value
  };
}
function getBearerToken(values) {
  var token = lodash.get(values, getBearerTokenTokenFormItemName());
  return {
    token: token
  };
}
function getJwt(values) {
  var addTokenTo = lodash.get(values, getJwtAddTokenToFormItemName());
  if (addTokenTo === securityScheme.SecurityParamterLocation.QUERY) {
    addTokenTo = 'queryParam';
  }
  var algorithm = lodash.get(values, getJwtAlgorithmFormItemName());
  var header = lodash.get(values, getJwtHeaderFormItemName()) || '';
  var headerPrefix = lodash.get(values, getJwtHeaderPrefixFormItemName());
  var queryParamKey = lodash.get(values, getJwtQueryParamKeyFormItemName());
  var isSecretBase64Encoded = lodash.get(values, getJwtIsSecretBase64EncodedFormItemName());
  var payload = lodash.get(values, getJwtPayloadFormItemName()) || '';
  var secret = lodash.get(values, getJwtSecretFormItemName());
  var privateKey = lodash.get(values, getJwtPrivateKeyFormItemName());
  var token = lodash.get(values, getJwtTokenFormItemName());
  return {
    addTokenTo: addTokenTo,
    algorithm: algorithm,
    header: header,
    headerPrefix: headerPrefix,
    queryParamKey: queryParamKey,
    isSecretBase64Encoded: isSecretBase64Encoded,
    payload: payload,
    secret: secret,
    privateKey: privateKey,
    token: token
  };
}
function getBasic(values) {
  var username = lodash.get(values, getBasicUsernameNamePath());
  var password = lodash.get(values, getBasicPasswordNamePath());
  return {
    username: username,
    password: password
  };
}
function getDigest(values) {
  var algorithm = lodash.get(values, getDigestAlgorithmNamePath());
  var username = lodash.get(values, getDigestUsernameNamePath());
  var password = lodash.get(values, getDigestPasswordNamePath());
  var clientNonce = lodash.get(values, getDigestClientNonceNamePath());
  var disableRetryRequest = lodash.get(values, getDigestDisableRetryRequestNamePath());
  var nonce = lodash.get(values, getDigestNonceNamePath());
  var nonceCount = lodash.get(values, getDigestNonceCountNamePath());
  var opaque = lodash.get(values, getDigestOpaqueNamePath());
  var qop = lodash.get(values, getDigestQopNamePath());
  var realm = lodash.get(values, getDigestRealmNamePath());
  return {
    algorithm: algorithm,
    username: username,
    password: password,
    clientNonce: clientNonce,
    disableRetryRequest: disableRetryRequest,
    nonce: nonce,
    nonceCount: nonceCount,
    opaque: opaque,
    qop: qop,
    realm: realm
  };
}
function getOAuth1(values) {
  var addEmptyParamsToSign = lodash.get(values, getOAuth1AddEmptyParamsToSignNamePath());
  var callback = lodash.get(values, getOAuth1CallbackNamePath());
  var consumerKey = lodash.get(values, getOAuth1ConsumerKeyNamePath());
  var consumerSecret = lodash.get(values, getOAuth1ConsumerSecretNamePath());
  var addTokenTo = lodash.get(values, getOAuth1AddTokenToNamePath());
  var includeBodyHash = lodash.get(values, getOAuth1IncludeBodyHashNamePath());
  var nonce = lodash.get(values, getOAuth1NonceNamePath());
  var realm = lodash.get(values, getOAuth1RealmNamePath());
  var signatureMethod = lodash.get(values, getOAuth1SignatureMethodNamePath());
  var timestamp = lodash.get(values, getOAuth1TimestampNamePath());
  var token = lodash.get(values, getOAuth1TokenNamePath());
  var tokenSecret = lodash.get(values, getOAuth1TokenSecretNamePath());
  var verifier = lodash.get(values, getOAuth1VerifierNamePath());
  var version = lodash.get(values, getOAuth1VersionNamePath());
  var enableHeaderEncoding = lodash.get(values, getOAuth1EnableHeaderEncodingNamePath());
  var privateKey = lodash.get(values, getOAuth1PrivateKeyNamePath());
  return {
    addEmptyParamsToSign: addEmptyParamsToSign,
    callback: callback,
    consumerKey: consumerKey,
    consumerSecret: consumerSecret,
    "in": addTokenTo,
    includeBodyHash: includeBodyHash,
    nonce: nonce,
    realm: realm,
    signatureMethod: signatureMethod,
    timestamp: timestamp,
    token: token,
    tokenSecret: tokenSecret,
    verifier: verifier,
    version: version,
    enableHeaderEncoding: enableHeaderEncoding,
    privateKey: privateKey
  };
}
function getHawk(values) {
  var algorithm = lodash.get(values, getHawkAlgorithmNamePath());
  var app = lodash.get(values, getHawkAppNamePath());
  var authId = lodash.get(values, getHawkAuthIdNamePath());
  var authKey = lodash.get(values, getHawkAuthKeyNamePath());
  var delegation = lodash.get(values, getHawkDelegationNamePath());
  var extraData = lodash.get(values, getHawkExtraDataNamePath());
  var includePayloadHash = lodash.get(values, getHawkIncludePayloadHashNamePath());
  var nonce = lodash.get(values, getHawkNonceNamePath());
  var timestamp = lodash.get(values, getHawkTimestampNamePath());
  var user = lodash.get(values, getHawkUserNamePath());
  return {
    algorithm: algorithm,
    app: app,
    authId: authId,
    authKey: authKey,
    delegation: delegation,
    extraData: extraData,
    includePayloadHash: includePayloadHash,
    nonce: nonce,
    timestamp: timestamp,
    user: user
  };
}
function getAws(values) {
  var accessKey = lodash.get(values, getAwsAccessKeyNamePath());
  var addTokenTo = lodash.get(values, authConfigsInFormItemName);
  var addAuthDataToQuery = false;
  var region = lodash.get(values, getAwsRegionNamePath());
  var secretKey = lodash.get(values, getAwsSecretKeyNamePath());
  var service = lodash.get(values, getAwsServiceNamePath());
  var sessionToken = lodash.get(values, getAwsSessionTokenNamePath());
  if (addTokenTo === securityScheme.SecurityParamterLocation.QUERY) {
    addTokenTo = 'url';
    addAuthDataToQuery = true;
  }
  return {
    accessKey: accessKey,
    "in": addTokenTo,
    addAuthDataToQuery: addAuthDataToQuery,
    region: region,
    secretKey: secretKey,
    service: service,
    sessionToken: sessionToken
  };
}
function getKerberos(values) {
  var service = lodash.get(values, getKerberosServiceNamePath());
  var mechOid = lodash.get(values, getKerberosMechOidNamePath());
  return {
    service: service,
    mech_oid: mechOid
  };
}
function getNtlm(values) {
  var disableRetryRequest = lodash.get(values, getNtlmDisableRetryRequestNamePath());
  var domain = lodash.get(values, getNtlmDomainNamePath());
  var password = lodash.get(values, getNtlmPasswordNamePath());
  var username = lodash.get(values, getNtlmUsernameNamePath());
  var workstation = lodash.get(values, getNtlmWorkstationNamePath());
  return {
    disableRetryRequest: disableRetryRequest,
    domain: domain,
    password: password,
    username: username,
    workstation: workstation
  };
}
function getEdgeGrid(values) {
  var accessToken = lodash.get(values, getEdgeGridAccessTokenNamePath());
  var baseURL = lodash.get(values, getEdgeGridBaseURLNamePath());
  var clientSecret = lodash.get(values, getEdgeGridClientSecretNamePath());
  var clientToken = lodash.get(values, getEdgeGridClientTokenNamePath());
  var headersToSign = lodash.get(values, getEdgeGridHeadersToSignNamePath());
  var nonce = lodash.get(values, getEdgeGridNonceNamePath());
  var timestamp = lodash.get(values, getEdgeGridTimestampNamePath());
  return {
    accessToken: accessToken,
    baseURL: baseURL,
    clientSecret: clientSecret,
    clientToken: clientToken,
    headersToSign: headersToSign,
    nonce: nonce,
    timestamp: timestamp
  };
}
var SecurityScheme = /*#__PURE__*/function () {
  function SecurityScheme(options) {
    _classCallCheck(this, SecurityScheme);
    this.id = options.id;
    this.projectId = options.projectId;
    this.name = options.name;
    this.authType = options.authType;
    this.oasAuthType = options.oasAuthType;
    this.authConfigs = options.authConfigs;
    this.guidanceConfigs = options.guidanceConfigs;
    this.folderId = options.folderId;
    this.createdAt = options.createdAt;
  }
  return _createClass(SecurityScheme, [{
    key: "setFolder",
    value: function setFolder(folder) {
      this.folder = folder;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        name: this.name,
        authType: this.authType,
        oasAuthType: this.oasAuthType,
        authConfigs: this.authConfigs,
        guidanceConfigs: this.guidanceConfigs,
        folderId: this.folderId,
        projectId: this.projectId,
        createdAt: this.createdAt
      };
    }
  }, {
    key: "toOAS",
    value: function toOAS() {
      return {
        name: this.name
      };
    }
  }]);
}();
exports.accessToken = accessToken;
exports.apiKeyDefaultName = apiKeyDefaultName;
exports.authConfigsBearerFormatFormItemName = authConfigsBearerFormatFormItemName;
exports.authConfigsFlowsFormItemName = authConfigsFlowsFormItemName;
exports.authConfigsGroupFormItemName = authConfigsGroupFormItemName;
exports.authConfigsInFormItemName = authConfigsInFormItemName;
exports.authConfigsName = authConfigsName;
exports.authConfigsNameFormItemName = authConfigsNameFormItemName;
exports.authConfigsSchemeFormItemName = authConfigsSchemeFormItemName;
exports.authConfigsTypeFormItemName = authConfigsTypeFormItemName;
exports.authTypeName = authTypeName;
exports.bearerFormatName = bearerFormatName;
exports.clientIdFormItemName = clientIdFormItemName;
exports.clientSecretFormItemName = clientSecretFormItemName;
exports.configsBaseNamePathInUseCase = configsBaseNamePathInUseCase;
exports.configsBaseNamePathInUseOverride = configsBaseNamePathInUseOverride;
exports.default = SecurityScheme;
exports.flowsName = flowsName;
exports.getAddTokenToFromItemName = getAddTokenToFromItemName;
exports.getApiKey = getApiKey;
exports.getApiKeyValueNamePathInUseCase = getApiKeyValueNamePathInUseCase;
exports.getAuthConfigsAccessTokenFormItemNameInUseCase = getAuthConfigsAccessTokenFormItemNameInUseCase;
exports.getAuthConfigsExtendedFieldBaseFormItemName = getAuthConfigsExtendedFieldBaseFormItemName;
exports.getAuthConfigsNamePathInUseCase = getAuthConfigsNamePathInUseCase;
exports.getAuthConfigsTokenDetailFormItemNameInUseCase = getAuthConfigsTokenDetailFormItemNameInUseCase;
exports.getAuthConfigsValueFormItemName = getAuthConfigsValueFormItemName;
exports.getAuthRequestParamsFormItemName = getAuthRequestParamsFormItemName;
exports.getAuthorizationUrlFormItemName = getAuthorizationUrlFormItemName;
exports.getAws = getAws;
exports.getAwsAccessKeyNamePath = getAwsAccessKeyNamePath;
exports.getAwsAccessKeyNamePathInUseCase = getAwsAccessKeyNamePathInUseCase;
exports.getAwsRegionNamePath = getAwsRegionNamePath;
exports.getAwsSchemeNamePath = getAwsSchemeNamePath;
exports.getAwsSecretKeyNamePath = getAwsSecretKeyNamePath;
exports.getAwsSecretKeyNamePathInUseCase = getAwsSecretKeyNamePathInUseCase;
exports.getAwsServiceNamePath = getAwsServiceNamePath;
exports.getAwsSessionTokenNamePath = getAwsSessionTokenNamePath;
exports.getAwsSessionTokenNamePathInUseCase = getAwsSessionTokenNamePathInUseCase;
exports.getBasic = getBasic;
exports.getBasicPasswordNamePath = getBasicPasswordNamePath;
exports.getBasicPasswordNamePathInUseCase = getBasicPasswordNamePathInUseCase;
exports.getBasicUsernameNamePath = getBasicUsernameNamePath;
exports.getBasicUsernameNamePathInUseCase = getBasicUsernameNamePathInUseCase;
exports.getBearerToken = getBearerToken;
exports.getBearerTokenTokenFormItemName = getBearerTokenTokenFormItemName;
exports.getBearerTokenTokenNamePathInUseCase = getBearerTokenTokenNamePathInUseCase;
exports.getCallbackUrlFormItemName = getCallbackUrlFormItemName;
exports.getChallengeAlgorithmFromItemName = getChallengeAlgorithmFromItemName;
exports.getClientIdFormItemName = getClientIdFormItemName;
exports.getClientSecretFormItemName = getClientSecretFormItemName;
exports.getCodeVerifierFromItemName = getCodeVerifierFromItemName;
exports.getConfigsForSechemeBaseNamePathInUseCase = getConfigsForSechemeBaseNamePathInUseCase;
exports.getConfigsForSechemeBaseNamePathInUseOverride = getConfigsForSechemeBaseNamePathInUseOverride;
exports.getCredentialsFormItemName = getCredentialsFormItemName;
exports.getDigest = getDigest;
exports.getDigestAlgorithmNamePath = getDigestAlgorithmNamePath;
exports.getDigestClientNonceNamePath = getDigestClientNonceNamePath;
exports.getDigestClientNonceNamePathInUseCase = getDigestClientNonceNamePathInUseCase;
exports.getDigestDisableRetryRequestNamePath = getDigestDisableRetryRequestNamePath;
exports.getDigestDisableRetryRequestNamePathInUseCase = getDigestDisableRetryRequestNamePathInUseCase;
exports.getDigestNonceCountNamePath = getDigestNonceCountNamePath;
exports.getDigestNonceCountNamePathInUseCase = getDigestNonceCountNamePathInUseCase;
exports.getDigestNonceNamePath = getDigestNonceNamePath;
exports.getDigestNonceNamePathInUseCase = getDigestNonceNamePathInUseCase;
exports.getDigestOpaqueNamePath = getDigestOpaqueNamePath;
exports.getDigestOpaqueNamePathInUseCase = getDigestOpaqueNamePathInUseCase;
exports.getDigestPasswordNamePath = getDigestPasswordNamePath;
exports.getDigestPasswordNamePathInUseCase = getDigestPasswordNamePathInUseCase;
exports.getDigestQopNamePath = getDigestQopNamePath;
exports.getDigestQopNamePathInUseCase = getDigestQopNamePathInUseCase;
exports.getDigestRealmNamePath = getDigestRealmNamePath;
exports.getDigestRealmNamePathInUseCase = getDigestRealmNamePathInUseCase;
exports.getDigestUsernameNamePath = getDigestUsernameNamePath;
exports.getDigestUsernameNamePathInUseCase = getDigestUsernameNamePathInUseCase;
exports.getEdgeGrid = getEdgeGrid;
exports.getEdgeGridAccessTokenNamePath = getEdgeGridAccessTokenNamePath;
exports.getEdgeGridAccessTokenNamePathInUseCase = getEdgeGridAccessTokenNamePathInUseCase;
exports.getEdgeGridBaseURLNamePath = getEdgeGridBaseURLNamePath;
exports.getEdgeGridBaseURLNamePathInUseCase = getEdgeGridBaseURLNamePathInUseCase;
exports.getEdgeGridClientSecretNamePath = getEdgeGridClientSecretNamePath;
exports.getEdgeGridClientTokenNamePath = getEdgeGridClientTokenNamePath;
exports.getEdgeGridHeadersToSignNamePath = getEdgeGridHeadersToSignNamePath;
exports.getEdgeGridHeadersToSignNamePathInUseCase = getEdgeGridHeadersToSignNamePathInUseCase;
exports.getEdgeGridNonceNamePath = getEdgeGridNonceNamePath;
exports.getEdgeGridNonceNamePathInUseCase = getEdgeGridNonceNamePathInUseCase;
exports.getEdgeGridSchemeNamePath = getEdgeGridSchemeNamePath;
exports.getEdgeGridTimestampNamePath = getEdgeGridTimestampNamePath;
exports.getEdgeGridTimestampNamePathInUseCase = getEdgeGridTimestampNamePathInUseCase;
exports.getExtendedFieldName = getExtendedFieldName;
exports.getGrantType = getGrantType;
exports.getHawk = getHawk;
exports.getHawkAlgorithmNamePath = getHawkAlgorithmNamePath;
exports.getHawkAppNamePath = getHawkAppNamePath;
exports.getHawkAppNamePathInUseCase = getHawkAppNamePathInUseCase;
exports.getHawkAuthIdNamePath = getHawkAuthIdNamePath;
exports.getHawkAuthIdNamePathInUseCase = getHawkAuthIdNamePathInUseCase;
exports.getHawkAuthKeyNamePath = getHawkAuthKeyNamePath;
exports.getHawkAuthKeyNamePathInUseCase = getHawkAuthKeyNamePathInUseCase;
exports.getHawkDelegationNamePath = getHawkDelegationNamePath;
exports.getHawkDelegationNamePathInUseCase = getHawkDelegationNamePathInUseCase;
exports.getHawkExtraDataNamePath = getHawkExtraDataNamePath;
exports.getHawkExtraDataNamePathInUseCase = getHawkExtraDataNamePathInUseCase;
exports.getHawkIncludePayloadHashNamePath = getHawkIncludePayloadHashNamePath;
exports.getHawkNonceNamePath = getHawkNonceNamePath;
exports.getHawkNonceNamePathInUseCase = getHawkNonceNamePathInUseCase;
exports.getHawkSchemeNamePath = getHawkSchemeNamePath;
exports.getHawkTimestampNamePath = getHawkTimestampNamePath;
exports.getHawkTimestampNamePathInUseCase = getHawkTimestampNamePathInUseCase;
exports.getHawkUserNamePath = getHawkUserNamePath;
exports.getHawkUserNamePathInUseCase = getHawkUserNamePathInUseCase;
exports.getHeaderKeyFormItemName = getHeaderKeyFormItemName;
exports.getHeaderPrefixFormItemName = getHeaderPrefixFormItemName;
exports.getJwt = getJwt;
exports.getJwtAddTokenToFormItemName = getJwtAddTokenToFormItemName;
exports.getJwtAlgorithmFormItemName = getJwtAlgorithmFormItemName;
exports.getJwtHeaderFormItemName = getJwtHeaderFormItemName;
exports.getJwtHeaderNamePathInUseCase = getJwtHeaderNamePathInUseCase;
exports.getJwtHeaderPrefixFormItemName = getJwtHeaderPrefixFormItemName;
exports.getJwtIsSecretBase64EncodedFormItemName = getJwtIsSecretBase64EncodedFormItemName;
exports.getJwtIsSecretBase64EncodedNamePathInUseCase = getJwtIsSecretBase64EncodedNamePathInUseCase;
exports.getJwtPayloadFormItemName = getJwtPayloadFormItemName;
exports.getJwtPayloadNamePathInUseCase = getJwtPayloadNamePathInUseCase;
exports.getJwtPrivateKeyFormItemName = getJwtPrivateKeyFormItemName;
exports.getJwtPrivateKeyNamePathInUseCase = getJwtPrivateKeyNamePathInUseCase;
exports.getJwtQueryParamKeyFormItemName = getJwtQueryParamKeyFormItemName;
exports.getJwtSecretFormItemName = getJwtSecretFormItemName;
exports.getJwtSecretNamePathInUseCase = getJwtSecretNamePathInUseCase;
exports.getJwtTokenFormItemName = getJwtTokenFormItemName;
exports.getJwtTokenNamePathInUseCase = getJwtTokenNamePathInUseCase;
exports.getKerberos = getKerberos;
exports.getKerberosMechOidNamePath = getKerberosMechOidNamePath;
exports.getKerberosMechOidNamePathInUseCase = getKerberosMechOidNamePathInUseCase;
exports.getKerberosServiceNamePath = getKerberosServiceNamePath;
exports.getNegotiateProviderNamePath = getNegotiateProviderNamePath;
exports.getNtlm = getNtlm;
exports.getNtlmDisableRetryRequestNamePath = getNtlmDisableRetryRequestNamePath;
exports.getNtlmDomainNamePath = getNtlmDomainNamePath;
exports.getNtlmPasswordNamePath = getNtlmPasswordNamePath;
exports.getNtlmPasswordNamePathInUseCase = getNtlmPasswordNamePathInUseCase;
exports.getNtlmUsernameNamePath = getNtlmUsernameNamePath;
exports.getNtlmUsernameNamePathInUseCase = getNtlmUsernameNamePathInUseCase;
exports.getNtlmWorkstationNamePath = getNtlmWorkstationNamePath;
exports.getOAuth1 = getOAuth1;
exports.getOAuth1AddEmptyParamsToSignNamePath = getOAuth1AddEmptyParamsToSignNamePath;
exports.getOAuth1AddTokenToNamePath = getOAuth1AddTokenToNamePath;
exports.getOAuth1CallbackNamePath = getOAuth1CallbackNamePath;
exports.getOAuth1CallbackNamePathInUseCase = getOAuth1CallbackNamePathInUseCase;
exports.getOAuth1ConsumerKeyNamePath = getOAuth1ConsumerKeyNamePath;
exports.getOAuth1ConsumerSecretNamePath = getOAuth1ConsumerSecretNamePath;
exports.getOAuth1EnableHeaderEncodingNamePath = getOAuth1EnableHeaderEncodingNamePath;
exports.getOAuth1IncludeBodyHashNamePath = getOAuth1IncludeBodyHashNamePath;
exports.getOAuth1NonceNamePath = getOAuth1NonceNamePath;
exports.getOAuth1NonceNamePathInUseCase = getOAuth1NonceNamePathInUseCase;
exports.getOAuth1PrivateKeyNamePath = getOAuth1PrivateKeyNamePath;
exports.getOAuth1PrivateKeyNamePathInUseCase = getOAuth1PrivateKeyNamePathInUseCase;
exports.getOAuth1RealmNamePath = getOAuth1RealmNamePath;
exports.getOAuth1RealmNamePathInUseCase = getOAuth1RealmNamePathInUseCase;
exports.getOAuth1SignatureMethodNamePath = getOAuth1SignatureMethodNamePath;
exports.getOAuth1TimestampNamePath = getOAuth1TimestampNamePath;
exports.getOAuth1TimestampNamePathInUseCase = getOAuth1TimestampNamePathInUseCase;
exports.getOAuth1TokenNamePath = getOAuth1TokenNamePath;
exports.getOAuth1TokenNamePathInUseCase = getOAuth1TokenNamePathInUseCase;
exports.getOAuth1TokenSecretNamePath = getOAuth1TokenSecretNamePath;
exports.getOAuth1TokenSecretNamePathInUseCase = getOAuth1TokenSecretNamePathInUseCase;
exports.getOAuth1VerifierNamePath = getOAuth1VerifierNamePath;
exports.getOAuth1VerifierNamePathInUseCase = getOAuth1VerifierNamePathInUseCase;
exports.getOAuth1VersionNamePath = getOAuth1VersionNamePath;
exports.getOAuth1VersionNamePathInUseCase = getOAuth1VersionNamePathInUseCase;
exports.getOAuth2 = getOAuth2;
exports.getOAuth2FlowsExtendedFieldBaseFormItemName = getOAuth2FlowsExtendedFieldBaseFormItemName;
exports.getOAuth2FlowsFieldBaseFormItemName = getOAuth2FlowsFieldBaseFormItemName;
exports.getOAuth2GrantTypeNamePathInUseCase = getOAuth2GrantTypeNamePathInUseCase;
exports.getPasswordFormItemName = getPasswordFormItemName;
exports.getPasswordFormItemNameInUseCase = getPasswordFormItemNameInUseCase;
exports.getQueryParamKeyFormItemName = getQueryParamKeyFormItemName;
exports.getRefreshRequestParamsFormItemName = getRefreshRequestParamsFormItemName;
exports.getRefreshUrlFormItemName = getRefreshUrlFormItemName;
exports.getScopesFormItemName = getScopesFormItemName;
exports.getStateFormItemName = getStateFormItemName;
exports.getTokenRequestParamsFormItemName = getTokenRequestParamsFormItemName;
exports.getTokenUrlFormItemName = getTokenUrlFormItemName;
exports.getUseTokenConfigAsRefreshTokenConfigFormItemName = getUseTokenConfigAsRefreshTokenConfigFormItemName;
exports.getUseTokenTypeFromItemName = getUseTokenTypeFromItemName;
exports.getUserNameFormItemName = getUserNameFormItemName;
exports.getUserNameFormItemNameInUseCase = getUserNameFormItemNameInUseCase;
exports.inName = inName;
exports.passwordFormItemName = passwordFormItemName;
exports.schemeName = schemeName;
exports.scopesFormItemName = scopesFormItemName;
exports.securitySchemeName = securitySchemeName;
exports.typeName = typeName;
exports.useCaseNamePathBase = useCaseNamePathBase;
exports.useGrantType = useGrantType;
exports.useOverrideNamePath = useOverrideNamePath;
exports.usernameFormItemName = usernameFormItemName;
